import { render } from "./LegalVersionViewerModal.vue?vue&type=template&id=2552b035&scoped=true"
import script from "./LegalVersionViewerModal.vue?vue&type=script&lang=js"
export * from "./LegalVersionViewerModal.vue?vue&type=script&lang=js"

import "./LegalVersionViewerModal.vue?vue&type=style&index=0&id=2552b035&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2552b035"]])

export default __exports__